import * as React from "react";
import { Input, Button } from "antd";
import Text from "antd/lib/typography/Text";
import whiteLogo from "../../assets/images/headerlogo.png";

const VerificationForm = ({
  translate,
  verificationCode,
  onChangeVerificationCode,
  title,
  submitVerificationCode,
  loading
}: {
  translate: any;
  verificationCode: string;
  onChangeVerificationCode: any;
  title: string;
  submitVerificationCode: any;
  loading: boolean;
}) => {
  return (
    <div className="login-container">
      <div className="login-header-container">
        <div>
          <img className="logo-container" src={whiteLogo} alt="Logo" />
        </div>

        <div className="login-subheader-container">
          <Text className="login-title">{translate(`app.${title}`)}</Text>
          <Text className="login-subtitle">{translate("app.name")}</Text>
        </div>
      </div>
      <div className="login-form-container">
        <div className="login-title-wrapper">
          <Text className="login-text ">
            {translate("verification_form.title")}
          </Text>
        </div>

        <div className="login-form-item-container" style={{ marginTop: 50 }}>
          <Input
            addonBefore={translate("verification_form.code")}
            value={verificationCode}
            onChange={(e) => onChangeVerificationCode(e.currentTarget.value)}
          />
          <Button
            type="primary"
            disabled={verificationCode ? false : true}
            onClick={submitVerificationCode}
            className="login-button"
            loading={loading}
          >
            {translate("verification_form.submit")}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default VerificationForm;
